import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Grid } from "gridjs";
import "gridjs/dist/theme/mermaid.css";
import "./Table.scss";

function Table({
  data,
  columns,
  stickyFirstColumn,
  pagination,
  sort,
  rowClickHandler,
  fixedHeader,
  height,
  resizeableColumns,
  setGridTableConfig=null
  // getSelectedRows=null
}) {

  const wrapperRef = useRef(null);
  const tableConfig = {
    data: data,
    columns: columns,
    className: { container: stickyFirstColumn ? "sticky-first-col" : "" },
    pagination: pagination,
    sort: sort,
    fixedHeader,
    height,
    resizable: resizeableColumns,
    style: {
      table: {
        "white-space": "nowrap",
      },
    },
  };

  const grid = new Grid(tableConfig);
  if (rowClickHandler) {
    grid.on("rowClick", (...args) => rowClickHandler(args));
  }

  useEffect(() => {
    wrapperRef.current.innerHTML = "";
    grid.render(wrapperRef.current);
    grid.updateConfig({ data }).forceRender();
  }, [data]);

  grid.on('ready',()=>{
    if(setGridTableConfig) setGridTableConfig(grid);
  })


  return <div className="table-container" ref={wrapperRef}></div>;
}

Table.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array,
  stickyFirstColumn: PropTypes.bool,
  pagination: PropTypes.shape({
    enabled: PropTypes.bool.isRequired,
    limit: PropTypes.number.isRequired,
  }),
  sort: PropTypes.bool.isRequired,
  rowClickHandler: PropTypes.func,
  fixedHeader: PropTypes.bool.isRequired,
  height: PropTypes.string,
  resizeableColumns: PropTypes.bool,
};

export default Table;
